import { useTranslation } from 'react-i18next';
import { supportedLanguages, supportedLanguageOptions } from '../lib/i18n';
import { getSystemLanguage, mapSystemLanguageToSupported } from '../utils/languageUtils';

/**
 * Hook for getting internationalized language display names
 */
export const useLanguageDisplayNames = () => {
  const { t } = useTranslation(['v3/me']);

  /**
   * 获取语言显示名称（包含系统语言信息）
   */
  const getLanguageDisplayName = (language: string): string => {
    if (language === 'system') {
      const systemLang = getSystemLanguage();
      const effectiveLang = mapSystemLanguageToSupported(systemLang);
      const systemLangName = supportedLanguages[effectiveLang];
      const followSystemText = t('v3/me:appearance.followSystem', { defaultValue: '跟随系统' });
      return `${followSystemText} (${systemLangName})`;
    }
    
    return supportedLanguageOptions[language as keyof typeof supportedLanguageOptions] || language;
  };

  /**
   * 获取所有语言选项的显示名称映射
   */
  const getLanguageOptionsWithDisplayNames = () => {
    return Object.keys(supportedLanguageOptions).reduce((acc, code) => {
      acc[code] = getLanguageDisplayName(code);
      return acc;
    }, {} as Record<string, string>);
  };

  return {
    getLanguageDisplayName,
    getLanguageOptionsWithDisplayNames
  };
};
